import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'isEdited', pure: true, standalone: true })
export class IsEditedPipe implements PipeTransform {
  transform(errorId: number | null, editedIds: ReadonlySet<number>): boolean {
    return errorId !== null && editedIds.has(errorId);
  }
}
